/**
 * @fileoverview Agent definition for world-species-details-generator-v3.
 *
 * This agent generates complete details for a world species based on a
 * selected creative direction from the details ideation agent.
 *
 * @category world-building.species.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-species-details-generator-v3',
  kind: 'primitive',
  name: 'World Species Details Generator',
  description: 'Generates complete details for a world species based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.species.details',
    usedBy: ['use-world-species-details-generator-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-species-details-ideation-v3',
      'world-species-snapshotter-v3',
    ],
  },
};
